module.exports = __webpack_public_path__ + "static/media/logotipo-estrella-galicia-00.25222b13.png";